import TileGridContainer from 'features/tiles/tileGridContainer';
import { FC } from 'react';
import TileWithoutDefaultStyling from 'features/tiles/tileWithoutDefaultStyling';
import { useDispatch, useSelector } from 'react-redux';
import CopyToClipboard from 'common/components/copy-to-clipboard/copy-to-clipboard';

export const SetupCallTrackingSettings: FC = () => {
  const dispatch = useDispatch();

  return (
    <TileGridContainer>
      <TileWithoutDefaultStyling className="bg-white border rounded border-neutral-200 p-2.5 shadow-sm w-full min-h-1/2-screen grow basis-full">
        <section className="mx-6 my-6">
          <h2 className="text-primary-700 text-l leading-7 mb-1 mt-2 ml-2">
            Configuring your site
          </h2>
          <div className="flex items-center ml-2">
            <hr className="border-t-1 border-neutral-200 flex-grow" />
          </div>
          <div className="text-sm mb-1 mt-2 ml-2">
            <p>
              In order to use phone tracking you must have the tracking tag
              installed.
            </p>
            <p className="mt-2">
              Then you will need your phone numbers enclosed in a HTML tag.
              Usually a <b>{'<div>'}</b> or <b>{'<span>'}</b> with a specific
              class name.
            </p>
            <div className="border border-neutral-200 mt-2 p-2 flex items-start">
              <code className="whitespace-pre">
                {'<!-- Simple tracking tags\n'}
                {'In these examples, your phone selector class is rulertel\n'}
                {
                  'Leave your static phone number between the span tags as this will display when javascript is not enabled on the client\n'
                }
                {'-->\n'}
                {"<span class='rulertel'>0800 000 0000</span>\n"}
                {'<!-- or this -->\n'}
                {"<div class='rulertel'>0800 111 11111</div>\n"}
                {'\n'}
                {'<!-- for mobile or click to call on desktops -->\n'}
                {
                  "<a class='rulertel' href='tel:08002222222'>0800 222 2222</a>\n"
                }
                {'\n'}
                {'<!--\n'}
                {
                  '  Anything within the phone call element will be replaced by the phone call text\n'
                }
                {'-->'}
              </code>
              <div className="ml-auto">
                <CopyToClipboard
                  code={`<!-- Simple tracking tags
                  In these examples your phone selector class is rulertel
                  Leave your static phone number between the span tags as this will display when javascript is not enabled on the client
                  -->
                  <span class='rulertel'>0800 000 0000</span>
                  <!-- or this -->
                  <div class='rulertel'>0800 111 11111</div>
                  
                  <!-- for mobile or click to call on desktops -->
                  <a class='rulertel' href='tel:08002222222'>0800 222 2222</a>
                  
                  <!--
                    Anything within the phone call element will be replaced by the phone call text
                  -->`}
                />
              </div>
            </div>
          </div>
        </section>
      </TileWithoutDefaultStyling>
      <TileWithoutDefaultStyling className="bg-white border rounded border-neutral-200 p-2.5 shadow-sm w-full  grow basis-full mt-3">
        <section className="mx-6 my-6">
          <h2 className="text-primary-700 text-l leading-7 mb-1 mt-2 ml-2">
            New or additional static and dynamic numbers
          </h2>
          <div className="flex items-center ml-2">
            <hr className="border-t-1 border-neutral-200 flex-grow" />
          </div>
          <div className="text-sm mb-1 mt-2 ml-2">
            <p>
              Please email{' '}
              <a
                href="mailto:support@ruleranalytics.com"
                className="text-primary-100"
              >
                support@ruleranalytics.com{' '}
              </a>
              to request phone call tracking or additional numbers
            </p>
            <p className="flex items-center mt-1">
              <i className="ra-icons-generic-information-1 leading-7 text-neutral-500 mr-2"></i>
              Refer to the{' '}
              <a
                href="https://ruler-documentation.readme.io/docs/phone-tracking"
                className="mx-1 text-primary-100"
              >
                integration guide
              </a>{' '}
              for site configuration details.
            </p>
          </div>
        </section>
      </TileWithoutDefaultStyling>
    </TileGridContainer>
  );
};
